import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CollapsibleService } from './services/collapsible-boxes.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-collapsible-box',
  templateUrl: './collapsible-box.component.html',
  styleUrls: ['./collapsible-box.component.scss'],
})
export class CollapsibleBoxComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() staticOnDesktop: boolean;
  @Input() themeType: string;
  @Input() iconClass: string;
  @Input() descriptiveId: string;
  public isOpen: boolean;
  private closeBoxesSubscription: Subscription;

  constructor(private collapsibleService: CollapsibleService) {
    this.title = '';
    this.staticOnDesktop = false;
    this.themeType = '';
    this.iconClass = '';
    this.descriptiveId = '';
    this.isOpen = false;
    this.closeBoxesSubscription = new Subscription();
  }

  ngOnInit() {
    this.closeBoxesSubscription = this.collapsibleService.boxExpanded.subscribe(() => this.isOpen = false);
  }

  ngOnDestroy() {
    this.closeBoxesSubscription.unsubscribe();
  }

  public get isStatic() { return this.staticOnDesktop ? 'static' : 'normal'; }

  public openBox() {
    if (!this.isOpen) { this.collapsibleService.collapseBoxes(); }
    this.isOpen = !this.isOpen;
  }
}
